export default __webpack_public_path__ + "static/media/Devon.e4be3e2e.png";